export default "__VITE_ASSET__DdSaNgqg__"